import React from "react";
import { Helmet } from "react-helmet";
import { defaultSeo } from "./seoMeta";

const CustomHelmet = ({ title, description = defaultSeo.description, keywords = defaultSeo.keywords }) => {
    const metaTitle = title || "客製化軟體開發 | 匯融科技";

    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="title" content={metaTitle} />
            <meta name="keywords" content={keywords} />
            <meta name="description" content={description} />
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11265085089"></script>
            <script>
                {`
                                window.dataLayer = window.dataLayer || [];
                                function gtag() {
                                    dataLayer.push(arguments)
                                }
                                gtag('js', new Date());
                                gtag('config', 'AW-11265085089');
                `}

            </script>
        </Helmet>
    );
}

export default CustomHelmet;